export default __webpack_public_path__ + "static/worksans-italic-webfont-6fa2284a9697c8ab159c96b86517c262.woff";